import { useSyncExternalStore } from 'react';

function mq(query: string) {
  return typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(query) : null;
}

export function useMedia(query: string): boolean {
  return useSyncExternalStore(
    (l) => {
      const m = mq(query);
      m?.addEventListener('change', l);
      return () => m?.removeEventListener('change', l);
    },
    () => !!mq(query)?.matches,
    () => false
  );
}

/** Desktop layout from 1024px wide. */
export const useDesktop = () => useMedia('(min-width: 1024px)');
